import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14104861"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_4 = { class: "ss-tela-titulo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Controle de Autorizações", -1))
const _hoisted_6 = { class: "atalhos" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1))
const _hoisted_8 = {
  style: {"color":"orange","font-size":"20px"},
  class: "anticon"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1))
const _hoisted_10 = { class: "anticon" }
const _hoisted_11 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"display":"flex","justify-content":"flex-end","padding-right":"10px"}
}
const _hoisted_12 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Responder", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "ss-tela-conteudo" }
const _hoisted_16 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda" }
const _hoisted_17 = { class: "ant-table-column-title" }
const _hoisted_18 = { class: "ant-table-column-sorter ant-table-column-sorter-full" }
const _hoisted_19 = { class: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "Ordenar crescente",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-up",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
  ])
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "caret-down",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-down",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
  ])
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 3,
  class: "acoes-item"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 4 }
const _hoisted_31 = {
  key: 5,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Solicitante:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Permissão:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data da Solicitação:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Detalhes :", -1))
const _hoisted_36 = { class: "acoes-item ss-alinhar-centro" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_41 = {
  class: "ant-input-affix-wrapper ss-paginacao-qtde-registros",
  style: {"margin-top":"0px"}
}
const _hoisted_42 = { class: "ant-input-suffix" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1))
const _hoisted_44 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_busca_avancada = _resolveComponent("busca-avancada")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_card = _resolveComponent("card")!
  const _component_requisicao_autorizacao_modal = _resolveComponent("requisicao-autorizacao-modal")!
  const _component_requisicao_autorizacao_resposta_modal = _resolveComponent("requisicao-autorizacao-resposta-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.state.identificadorRecurso, [_ctx.state.empresaSelecionada]))
              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 0,
                  placement: "bottom"
                }, {
                  title: _withCtx(() => [
                    _hoisted_7
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.state.identificadorRecurso, [_ctx.state.empresaSelecionada])))
                    }, [
                      _createElementVNode("i", _hoisted_8, [
                        _createVNode(_component_icone, { nome: "estrela" })
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 1,
                  placement: "bottom"
                }, {
                  title: _withCtx(() => [
                    _hoisted_9
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.state.identificadorRecurso, [_ctx.state.empresaSelecionada])))
                    }, [
                      _createElementVNode("i", _hoisted_10, [
                        _createVNode(_component_icone, { nome: "favorito" })
                      ])
                    ])
                  ]),
                  _: 1
                }))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            style: {"min-width":"100px","text-align":"center"},
            type: "button",
            class: "ant-btn ant-btn-primary ss-btn-tela",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.abrirResposta && _ctx.abrirResposta(...args)))
          }, _hoisted_14)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_a_collapse, {
          ghost: "",
          class: "ss-accordion"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse_panel, {
              key: "1",
              header: "BUSCA AVANÇADA"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_busca_avancada, {
                  buscaAvancada: _ctx.state.buscaAvancada,
                  "onUpdate:buscaAvancada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
                  empresas: [_ctx.state.empresaSelecionada],
                  onAplicarFiltros: _ctx.aplicarFiltros
                }, null, 8, ["buscaAvancada", "empresas", "onAplicarFiltros"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_card, { titulo: "REQUISIÇÕES" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              columns: _ctx.gradeBase.colunas.filter(item => item.visible),
              "data-source": _ctx.state.requisicoes,
              rowKey: "codigo",
              pagination: false,
              loading: _ctx.telaBase.carregando,
              scroll: _ctx.gradeBase.layoutMobile ? null : { y: _ctx.window.innerHeight - 300 },
              "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
              size: "small"
            }, {
              headerCell: _withCtx(({ column }) => [
                (column.ordering)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: column.key,
                      class: "ss-coluna-ordenada"
                    }, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(column.title), 1),
                      _createElementVNode("span", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(), _createElementBlock("a", {
                            title: "Ordenação crescente",
                            key: 'ord-asc' + column.key,
                            class: _normalizeClass([_ctx.ordenacaoAtiva(column.key, 'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                            onClick: ($event: any) => (_ctx.ordenarDados(column.key, 'ASC'))
                          }, _hoisted_22, 10, _hoisted_20)),
                          (_openBlock(), _createElementBlock("a", {
                            title: "Ordenação decrescente",
                            key: 'ord-desc' + column.key,
                            class: _normalizeClass([_ctx.ordenacaoAtiva(column.key, 'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                            onClick: ($event: any) => (_ctx.ordenarDados(column.key, 'DESC'))
                          }, _hoisted_25, 10, _hoisted_23))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_26, [
                      _createElementVNode("span", null, _toDisplayString(text), 1)
                    ]))
                  : (column.key === 'MotivoRequisicao')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        style: {"white-space":"pre-wrap!important"},
                        innerHTML: _ctx.estilizarMotivoRequisicao(record.motivoRequisicao)
                      }, null, 8, _hoisted_27))
                    : (column.key === 'Status')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_component_a_tag, {
                            class: _normalizeClass('ss-tag-status ' + _ctx.servicoControleAutorizacoes.obterDescricaoStatusRequisicao(record.status))
                          }, null, 8, ["class"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.servicoControleAutorizacoes.obterDescricaoStatusRequisicao(record.status)), 1)
                        ], 64))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("a", {
                              class: "visualizar",
                              onClick: ($event: any) => (_ctx.abrirDetalhe(record))
                            }, [
                              _createVNode(_component_icone, { nome: "visualizar" })
                            ], 8, _hoisted_29)
                          ]))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(text)), 1))
                          : (column.key === 'RequisicaoAutorizacao')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("span", null, [
                                  _hoisted_32,
                                  _createTextVNode(" " + _toDisplayString(record.nomeUsuarioRequerente), 1)
                                ]),
                                _createElementVNode("span", null, [
                                  _hoisted_33,
                                  _createTextVNode(" " + _toDisplayString(record.descricaoPermissao), 1)
                                ]),
                                _createElementVNode("span", null, [
                                  _hoisted_34,
                                  _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(record.dataRequisicao)), 1)
                                ]),
                                _createElementVNode("span", null, [
                                  _hoisted_35,
                                  _createTextVNode(_toDisplayString(record.motivoRequisicao), 1)
                                ]),
                                _createVNode(_component_a_tag, {
                                  title: text,
                                  class: _normalizeClass('ss-tag-status ' + _ctx.servicoControleAutorizacoes.obterDescricaoStatusRequisicao(record.status))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.servicoControleAutorizacoes.obterDescricaoStatusRequisicao(record.status)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["title", "class"]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("a", {
                                    class: "visualizar",
                                    onClick: ($event: any) => (_ctx.abrirDetalhe(record))
                                  }, [
                                    _createVNode(_component_icone, { nome: "visualizar" })
                                  ], 8, _hoisted_37)
                                ])
                              ]))
                            : _createCommentVNode("", true)
              ]),
              emptyText: _withCtx(() => [
                _createVNode(_component_mensagem_sem_dados, {
                  resultadoPesquisa: !_ctx.telaBase.carregando,
                  mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
                }, null, 8, ["resultadoPesquisa", "mensagem"])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_a_pagination, {
                  class: "ss-paginacao-completa",
                  current: _ctx.state.paginacao.current,
                  "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.paginacao.current) = $event)),
                  size: "small",
                  total: _ctx.state.paginacaoApi.totalRegistros,
                  "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} registros`,
                  "page-size": _ctx.state.paginacao.pageSize,
                  pageSizeOptions: _ctx.state.paginacao.pageSizeOptions,
                  onShowSizeChange: _ctx.mostrarNovaPagina,
                  onChange: _ctx.mudarPagina
                }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.totalRegistrosComMascara) = $event)),
                    onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.alterarQuantidadeRegistroTotal(($event.target as HTMLInputElement).value))),
                    placeholder: "Total registros",
                    type: "text",
                    class: "ant-input hidden"
                  }, null, 544), [
                    [_vModelText, _ctx.state.totalRegistrosComMascara],
                    [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
                  ]),
                  _createElementVNode("span", _hoisted_42, [
                    _createVNode(_component_a_tooltip, { placement: "top" }, {
                      title: _withCtx(() => [
                        _hoisted_43
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_44, [
                          _createVNode(_component_icone, { nome: "informacoes" })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_requisicao_autorizacao_modal, {
      visivel: _ctx.state.exibirDetalhe,
      "onUpdate:visivel": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.exibirDetalhe) = $event)),
      requisicao: _ctx.state.requisicaoSelecionada,
      onConfirmacao: _ctx.buscarRequisicoes
    }, null, 8, ["visivel", "requisicao", "onConfirmacao"]),
    _createVNode(_component_requisicao_autorizacao_resposta_modal, {
      visivel: _ctx.state.exibirResposta,
      "onUpdate:visivel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.exibirResposta) = $event)),
      codigos: _ctx.state.codigosResposta,
      onConfirmacao: _ctx.buscarRequisicoes
    }, null, 8, ["visivel", "codigos", "onConfirmacao"])
  ]))
}